import { atom } from 'infrastructure/state/jotai.wrapper'
import { INode } from 'shared/types/tree'
import { doMapByTitleMatch, getDoQuestionsMatch } from './utility'
import { createIdMap } from '../../version_mapping/utility'

export const destinationTreeAtom = atom<{ tree?: INode; resetTree?(): void }>(
  {},
)
export const sourceTreeAtom = atom<INode | undefined>(undefined)

export const flowIdsAtom = atom<string[]>([])

export const sourceTreeIdMap = atom((get) => {
  const tree = get(sourceTreeAtom)
  if (!tree) return
  return createIdMap(tree)
})

export const destTreeIdMap = atom((get) => {
  const { tree } = get(destinationTreeAtom)
  if (!tree) return
  return createIdMap(tree)
})

export const activityNodeMapAtom = atom<Record<string, INode[]>>((get) => {
  const sourceTree = get(sourceTreeAtom)
  const { tree: destTree } = get(destinationTreeAtom)
  if (!sourceTree || !destTree) {
    return {} as Record<string, INode[]>
  }
  return doMapByTitleMatch({ sourceTree, destTree })
})

export const unMappedActivityNodes = atom((get) => {
  const nodeMap = get(activityNodeMapAtom)

  return Object.entries(nodeMap).reduce<string[]>((acc, [nodeId, entry]) => {
    if (entry.length === 1) return acc
    return [...acc, nodeId]
  }, [])
})

export const mappedActivityNodes = atom((get) => {
  const nodeMap = get(activityNodeMapAtom)

  return Object.entries(nodeMap).reduce<string[]>((acc, [nodeId, entry]) => {
    if (entry.length !== 1) return acc
    return [...acc, nodeId]
  }, [])
})

export const verifiedNodeIdsAtom = atom((get) => {
  const nodeMapping = get(activityNodeMapAtom)
  const mappedNodes = get(mappedActivityNodes)
  const destIdMap = get(destTreeIdMap)

  if (!destIdMap) return []

  return mappedNodes.filter((destinationNodeId) => {
    const { node: destNode } = destIdMap[destinationNodeId]
    const sourceNode = nodeMapping[destinationNodeId][0]
    return getDoQuestionsMatch(destNode, sourceNode)
  })
})
